module.exports = __webpack_public_path__ + "img/bg-pricing.4d2f2f4b.jpg";